import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../../actions/addresses";
import SecretSeedModal from "../sharedComponent/secretSeedModal";
import BalanceSummary from "../sharedComponent/balanceSummary";
import { usePrevious } from "../../../hooks/usePrevious";
import SenderDeleteModal from "../sharedComponent/senderDeleteModal";
import BoaAddSenderModal from "../sharedComponent/BoaAddSenderModal";
import {
  Amount,
  KeyPair,
  WalletResultCode,
  WalletTxBuilderSingleReceiver,
  WalletMA,
  Event,
} from "boa-sdk-ts";
import { ErrorCheckUtil } from "../../../utils/ErrorCheckUtil";
import CopyKeyPairModal from "../sharedComponent/copyKeyPairModal";
import CreateReceiver from "../sharedComponent/createReceiver";
import FeeOption from "../sharedComponent/feeOption";
import * as sdk from "boa-sdk-ts";
import { amountFormat, saveWalletData } from "../../../utils/WalletUtils";
import TransactionOverview from "../sendBoa/sendBoaOverview";

const Freezing = (props) => {
  // These are states of current component
  const { t, selectedAddress } = props;

  const [units, setUnits] = useState("");
  const [unitsError, setUnitsError] = useState("");
  const [amount, setAmount] = useState();
  const [freezingFee, setFreezingFee] = useState();
  const [accountName, setAccountName] = useState("");
  const [openCreateKeyPairModal, setOpenCreateKeyPairModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [fee, SetFee] = useState("");

  const [FeeError, SetFeeError] = useState(null);
  const [openConfirmDeletion, setConfirmDeletion] = useState(false);
  const [error, setError] = useState("");

  const [senderListLoader, setSenderListLoader] = useState(false);
  const [customFeeStatus, setCustomFeeStatus] = useState(false);
  const [receiverInfo, setReceiverInfo] = useState();

  //refactoring
  const [feeOption, setFeeOption] = useState("1");
  const [deletedAccount, setDeletedAccount] = useState();

  const [senderList, setSenderList] = useState([]);
  const [readModeList, setReadModeList] = useState([]);
  const [secretKeyModal, setSecretKeyModal] = useState(false);
  const [transactionOverviewData, setTransactionOverviewData] = useState();

  const { accounts, builders, client } = WalletMA.instance();

  useEffect(() => {
    console.log("FREEZING_INIT");
    initBuilder();
    return () => {
      console.log("FREEZING_END");
      const builder = getBuilder();
      if (builder) {
        builder.removeEventListener(Event.CHANGE_BALANCE, buildersEventHandler);
        builder.removeEventListener(
          Event.CHANGE_RECEIVER,
          buildersEventHandler
        );
        builder.removeEventListener(Event.CHANGE_SENDER, buildersEventHandler);
        builder.removeEventListener(Event.CHANGE_TX_FEE, buildersEventHandler);
        builder.removeEventListener(Event.ERROR, buildersEventHandler);
        builder.clear();
      }
      builders.delete("FREEZING");
    };
  }, []);

  const initBuilder = async () => {
    const res = await createBuilder();
    setBuilder(res);
  };

  const createBuilder = async () => {
    const builder = new WalletTxBuilderSingleReceiver(client);
    builder.addEventListener(Event.CHANGE_BALANCE, buildersEventHandler);
    builder.addEventListener(Event.CHANGE_RECEIVER, buildersEventHandler);
    builder.addEventListener(Event.CHANGE_SENDER, buildersEventHandler);
    builder.addEventListener(Event.CHANGE_TX_FEE, buildersEventHandler);
    builder.addEventListener(Event.CHANGE_FREEZING_FEE, buildersEventHandler);
    builder.addEventListener(Event.ERROR, buildersEventHandler);
    const account = accounts.selected_account;
    if (account) {
      await builder.addSender(account, account.balance.spendable);
    }
    await builder.setOutputType(sdk.OutputType.Freeze);
    return builder;
  };

  const buildersEventHandler = (e, data) => {
    console.log("Event > Freezing > Builder:" + e + " => " + data);
    switch (e) {
      case Event.CHANGE_BALANCE:
        break;
      case Event.CHANGE_RECEIVER:
        break;
      case Event.CHANGE_SENDER:
        const b = getBuilder();
        if (b) {
          setSenderList([...getBuilder().senders.items]);
        }
        break;
      case Event.CHANGE_TX_FEE:
        SetFee(data);
        break;
      case Event.CHANGE_FREEZING_FEE:
        setFreezingFee(data);
        break;
      case Event.ERROR:
        console.log("Event.ERROR:");
        break;
      default:
        break;
    }
  };

  // Reset all properties if account change from navbar.
  useEffect(() => {
    // if show confirm page true and account change then just hide confirm page.
    if (showConfirm) {
      setShowConfirm(false);
    }
    if (selectedAddress) {
      replaceSender();
    }
  }, [selectedAddress]);

  useEffect(() => {
    if (receiverInfo) {
      setOpenCreateKeyPairModal(true);
    }
  }, [receiverInfo]);

  useEffect(() => {
    if (units === "") {
      setAmount(null);
      if (getBuilder()) getBuilder().setReceiverAmount(Amount.make(0));
    } else {
      const amount = Amount.make((units * 10000 + 40000) * 10000000);
      setAmount(amount);
      if (getBuilder()) getBuilder().setReceiverAmount(amount);
    }
  }, [units]);

  // Change Fee Option Effect
  useEffect(() => {
    if (getBuilder()) {
      getBuilder().setFeeOption(parseFloat(feeOption));
    }
  }, [feeOption]);

  // method to  handle units
  const changeUnitsHandler = (e) => {
    const value = e.target.value;
    if (!value) {
      setUnits("");
    } else {
      if (/^[0-9]*$/.test(e.target.value)) {
        const f = parseFloat(e.target.value);
        if (f >= 0 && f <= 996) {
          setUnitsError("");
          setUnits(f.toString());
        } else if (value > 996) {
          setUnitsError(t("Enter_units_to_stake_for_flash_upto_996"));
        }
      } else {
        setUnits("0");
        setUnitsError(t("Enter_units_to_stake_for_flash_upto_996"));
      }
    }
  };

  const replaceSender = async () => {
    const b = getBuilder();
    if (b) {
      await b.clearSender(false);
      await b.addSender(
        accounts.selected_account,
        accounts.selected_account.balance.spendable
      );
    }
  };

  // Method to create new Account
  const handleCreatedValidatorAddress = async () => {
    const keyPair = KeyPair.random();
    setReceiverInfo(keyPair);
    getBuilder().setReceiverAddress(keyPair.address);
  };

  //when receiver address change it will show keys modal

  const closeKeyPairModalHandler = () => {
    setOpenCreateKeyPairModal(false);
  };

  var countDecimals = function (value) {
    let text = value.toString();
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf("e-") > -1) {
      let [base, trail] = text.split("e-");
      let deg = parseInt(trail, 10);
      return deg;
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== value) {
      return value.toString().split(".")[1].length || 0;
    }
    return 0;
  };

  const onChangeFee = (evt) => {
    //TODO : CHange custom Fee
    /*setCustomFeeStatus(true);
    let isDecimal = /^[-+]?[0-9]+\.[0-9]+$/.test(evt.target.value);
    if (isDecimal) {
      let noDigitAfterDecimal = countDecimals(evt.target.value);
      if (noDigitAfterDecimal > 7) {
        evt.preventDefault();
      } else {
        if (evt.keyCode === 8) {
          SetFee(evt.target.value);
        }
        //  else if (evt.keyCode < 48 || (evt.keyCode > 57 && evt.keyCode < 96)) {
        //   evt.preventDefault();
        // }
        else {
          SetFee(evt.target.value);
        }
      }
    } else {
      if (evt.keyCode === 8) {
        SetFee(evt.target.value);
      }
      //  else if (evt.keyCode < 48 || (evt.keyCode > 57 && evt.keyCode < 96)) {
      //   evt.preventDefault();
      // }
      else {
        SetFee(evt.target.value);
      }
    }*/
  };

  const setFeeOptionEvent = async (e) => {
    // New sender should remove custom fee effect
  };

  const previousAmount = usePrevious(amount);

  const prveviousFee = usePrevious(fee);

  // Delete transcation  from list
  const deleteTranscationSummary = (deletedRecord, index) => {
    setConfirmDeletion(true);
  };

  // Method to hide confirm div
  const hideConfirmDiv = () => {
    setShowConfirm(false);
  };

  const secretSeedModalCloseHandler = () => {
    setSecretKeyModal(false);
    if (getBuilder().getReadOnlyAccount().length === 0) {
      getTransactionOverview();
    }
  };

  const getBuilder = () => {
    return builders.get("FREEZING");
  };
  const setBuilder = (builder) => {
    builders.set("FREEZING", builder);
  };

  // FeeOptionChangeEvent
  const feeOptionChangeHandler = async (e) => {
    setFeeOption(e.target.value);
  };

  // Delete Sender transaction from list
  const deleteSender = (deletedRecord) => {
    setConfirmDeletion(true);
    setDeletedAccount(deletedRecord.account);
  };

  // Method to handletranscation
  const nextTransactionOverview = async (e) => {
    let readModeList = getBuilder().getReadOnlyAccount();
    if (readModeList.length > 0) {
      setReadModeList(readModeList);
      setSecretKeyModal(true);
    } else {
      getTransactionOverview();
    }
  };

  const deleteSenderConfirm = (value) => {
    if (value) {
      const builder = getBuilder();
      builder.removeSender(deletedAccount);
    }
    setDeletedAccount(null);
    setConfirmDeletion(false);
  };

  const getTransactionOverview = async (e) => {
    const builder = getBuilder();
    const res = await builder.getTransactionOverview();
    if (ErrorCheckUtil.resCodeCheck(res) && res.data) {
      setTransactionOverviewData(res.data);
      setShowConfirm(true);
    }
  };

  // Method to send Agora Transaction
  const sendToAgoraTransaction = async () => {
    const builder = getBuilder();
    const tx_res = builder.buildTransaction();

    if (ErrorCheckUtil.resCodeCheck(tx_res)) {
      const tx = tx_res.data;
      const res = await client.sendTransaction(tx);
      if (ErrorCheckUtil.resCodeCheck(res)) {
        await accounts.add(
          accountName ? accountName : receiverInfo.address.toString(),
          receiverInfo.secret,
          true,
          false
        );
        saveWalletData();
        props.history.push("/success");
      }
    }
  };
  const addSenderHandler = (account) => {
    if (account) {
      const builder = getBuilder();
      builder.addSender(account, account.balance.spendable);
    }
  };

  return (
    <>
      {showConfirm ? (
        <TransactionOverview
          hideConfirmDiv={hideConfirmDiv}
          sendToAgoraTransaction={sendToAgoraTransaction}
          transactionOverviewData={transactionOverviewData}
        />
      ) : (
        <div className="Content">
          <div className="TableBg cardBg">
            <div className="ContHeader pendingTable">
              <h3>{t("Freezing_Amount")} </h3>
            </div>
            <div className="ReceiveInput">
              <div className="addressInput">
                <TextField
                  label={t("units_to_Stake_for_Flash")}
                  type="number"
                  value={units}
                  InputProps={{ inputProps: { min: 0, max: 996 } }}
                  onChange={changeUnitsHandler}
                  onKeyDown={(e) => {
                    if (e.keyCode < 48 && e.keyCode > 57) {
                      e.preventDefault();
                    }
                  }}
                />
                <span className="validText">{unitsError}</span>
              </div>
              <div className="AmountInput">
                <TextField
                  label={t("Amount")}
                  type="text"
                  value={amountFormat(amount, 0)}
                  helperText=""
                  disabled
                />
                <span className="boa">BOA</span>
              </div>
              <div className="AmountInput">
                <TextField
                  label={t("Freezing_Fee")}
                  type="text"
                  value={amountFormat(freezingFee)}
                  helperText=""
                  disabled
                />
                <span className="boa">BOA</span>
              </div>
            </div>
          </div>
          <CreateReceiver
            setAccountName={setAccountName}
            accountName={accountName}
            handleCreatedValidatorAddress={handleCreatedValidatorAddress}
            receiverInfo={receiverInfo}
          />
          {/* Select Fee Option Component */}
          <FeeOption
            fee={fee}
            feeOption={feeOption}
            error={FeeError}
            feeOptionChangeHandler={feeOptionChangeHandler}
          />
          <div className="TableBg cardBg mt-30">
            {/* BOA Add Sender Modal Component */}
            <BoaAddSenderModal
              senderList={senderList}
              senderBtnStatus={
                getBuilder() &&
                getBuilder().remaining &&
                parseFloat(getBuilder().remaining.toString()) > 0
                  ? false
                  : true
              }
              remaining={getBuilder() && getBuilder().remaining}
              addSenderHandler={addSenderHandler}
            />
            {/* Sender List Balance Summary Component  */}
            <BalanceSummary
              props={props}
              senderList={senderList}
              deleteSender={deleteSender}
              senderListLoader={senderListLoader}
            />
            <div className="TransactionFee">
              {/* Button to redirect Send BOA transaction screen */}
              <div />
              <button
                className="btn btn-default senderBtn"
                disabled={
                  getBuilder() &&
                  getBuilder().validate().code === WalletResultCode.Success
                    ? false
                    : true
                }
                color="primary"
                onClick={(e) => nextTransactionOverview(e)}
              >
                {t("NEXT")}
              </button>
            </div>
          </div>
        </div>
      )}
      <CopyKeyPairModal
        closeKeyPairModalHandler={closeKeyPairModalHandler}
        openCreateKeyPairModal={openCreateKeyPairModal}
        receiverInfo={receiverInfo}
      />
      <SecretSeedModal
        readModeList={readModeList}
        secretKeyModal={secretKeyModal}
        secretSeedModalCloseHandler={secretSeedModalCloseHandler}
      />
      {/* Delete Sender Confirmation Modal  */}
      <SenderDeleteModal
        deleteSenderConfirm={deleteSenderConfirm}
        openConfirmDeletion={openConfirmDeletion}
      />
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Freezing))
);
